import { Router } from '@angular/router';
import { NavigationParams } from 'src/app/models/navigation/navigationParams.interface';
import { IRoutesQueryParamsFactory } from './routeQueryParamsFactory.inteface';

export class RoutesQueryParamsFactory implements IRoutesQueryParamsFactory {
  constructor(private readonly _router: Router) {}

  public create(foundParams: NavigationParams): NavigationParams | undefined {
    if (this._router.url.includes('integrations')) {
      return this._integrationsQueryParamsCreation(foundParams);
    } else if (this._router.url.includes('violations')) {
      return this._violationsQueryParamsCreation(foundParams);
    } else if (this._router.url.includes('inventory')) {
      return this._inventoryQueryParamsCreation(foundParams);
    } else if (this._router.url.includes('hygiene')) {
      return this._hygieneQueryParamsCreation(foundParams);
    } else if (this._router.url.includes('policies')) {
      return this._policyQueryParamsCreation(foundParams);
    } else if (this._router.url.includes('ai-detection') && this._router.url.includes('tab=activity')) {
      return this._agentStepQueryParamsCreation(foundParams);
    } else if (this._router.url.includes('ai-detection') && this._router.url.includes('tab=findings')) {
      return this._findingQueryParamsCreation(foundParams);
    } else if (this._router.url.includes('ai-detection') && this._router.url.includes('tab=prevention')) {
      return this._preventionQueryParamsCreation(foundParams);
    } else if (this._router.url.includes('ai-detection') && this._router.url.includes('tab=in-line-control')) {
      return this._inLineControlQueryParamsCreation(foundParams);
    } else if (this._router.url.includes('issues')) {
      return this._issuesQueryParamsCreation(foundParams);
    }

    return undefined;
  }

  private _findingQueryParamsCreation(foundParams: NavigationParams): NavigationParams | undefined {
    if (foundParams.integration && Object.keys(foundParams).length == 2 && foundParams.finding) {
      return foundParams;
    } else if (
      foundParams.integration &&
      Object.keys(foundParams).length == 4 &&
      foundParams.agentStep &&
      foundParams.stepThreadId &&
      foundParams.finding
    ) {
      return foundParams;
    }

    return undefined;
  }

  private _preventionQueryParamsCreation(foundParams: NavigationParams): NavigationParams | undefined {
    if (foundParams.integration && Object.keys(foundParams).length == 2 && foundParams.preventionId) {
      return { showPrevention: true };
    }

    return undefined;
  }

  private _agentStepQueryParamsCreation(foundParams: NavigationParams): NavigationParams | undefined {
    if (
      foundParams.integration &&
      Object.keys(foundParams).length == 3 &&
      foundParams.agentStep &&
      foundParams.stepThreadId
    ) {
      return foundParams;
    }

    return undefined;
  }

  private _inLineControlQueryParamsCreation(foundParams: NavigationParams): NavigationParams | undefined {
    if (foundParams.integration && Object.keys(foundParams).length == 2 && foundParams.inLineControl) {
      return foundParams;
    }

    return undefined;
  }

  private _integrationsQueryParamsCreation(foundParams: NavigationParams): NavigationParams | undefined {
    if (foundParams.integration && Object.keys(foundParams).length == 1) {
      return foundParams;
    }

    return undefined;
  }

  private _policyQueryParamsCreation(foundParams: NavigationParams): NavigationParams | undefined {
    if (foundParams.integration && Object.keys(foundParams).length == 1) {
      return foundParams;
    }
    return undefined;
  }

  private _violationsQueryParamsCreation(foundParams: NavigationParams): NavigationParams | undefined {
    if (
      foundParams.integration &&
      Object.keys(foundParams).length == 2 &&
      (foundParams.violation || foundParams.resource)
    ) {
      return foundParams;
    }

    return undefined;
  }

  private _hygieneQueryParamsCreation(foundParams: NavigationParams): NavigationParams | undefined {
    if (
      foundParams.integration &&
      Object.keys(foundParams).length == 2 &&
      (foundParams.violation || foundParams.resource)
    ) {
      return foundParams;
    }

    return undefined;
  }

  private _issuesQueryParamsCreation(foundParams: NavigationParams): NavigationParams | undefined {
    if (foundParams.integration && Object.keys(foundParams).length == 2 && foundParams.issue) {
      return foundParams;
    }

    return undefined;
  }

  private _inventoryQueryParamsCreation(foundParams: NavigationParams): NavigationParams | undefined {
    if (
      foundParams.integration &&
      Object.keys(foundParams).length == 2 &&
      (foundParams.violation || foundParams.resource)
    ) {
      return foundParams;
    }

    return undefined;
  }
}
